import React from "react";

function IsToShow(props) {
  if (props.show) return <>{props.children}</>;
  return <></>;
}

export default IsToShow;
